import React from 'react';

import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';

import { Badge } from '../../components/ui/badge';
import { toast } from 'sonner';

import { Users, UserPlus, Trash2, Shield, AlertTriangle, Calendar, Key, Settings, Bell, TrendingUp, Activity, BarChart3, FileText, Globe, Zap, Building, Building2, CreditCard, Database, FolderOpen, Layers, Calculator, BookOpen, Video, DollarSign, Package, FilePlus, Handshake, Receipt, Mail, User, FileSignature, Home, HardDrive, Gift, Megaphone, Landmark, QrCode, Award, History, Recycle } from 'lucide-react';

import '../../styles/print-institutional.css';

// Import des composants Phase 3
import AlertsExpiringContracts from '../../components/AlertsExpiringContracts';
import AgendaPartage from '../../components/AgendaPartage';
import GestionRoles from '../../components/GestionRoles';
import GestionConventions from '../../components/GestionConventions';
import GestionAssignations from '../../components/GestionAssignations';
import CartographieGlobale from '../../components/CartographieGlobale';
import ExportImportData from '../../components/ExportImportData';

import VideoManager from '../../components/GED/VideoManager';
import CodeHealthDashboard from '../../components/CodeHealthDashboard';
import FrontOfficeNavPanel from '../../components/FrontOfficeNavPanel';
import FrontOfficeFooterPanel from '../../components/FrontOfficeFooterPanel';

import GEDESS from '../../components/GED/GEDESS';
import GEDDomium from '../../components/GED/GEDDomium';
import GEDUniverselle from '../../components/GED/GEDUniverselle';
import GEDDossiers from '../../components/GED/GEDDossiers';
import GEDStatistiques from '../../components/GED/GEDStatistiques';

import GestionCoopersExperts from '../../components/GestionCoopersExperts';
import ValidationVirementsESS from '../../components/ValidationVirementsESS';

import GestionDemandesPartenariat from '../../components/GestionDemandesPartenariat';
import RemisesStatsPanel from '../../components/RemisesStatsPanel';
import MessagerieDashboard from '../../components/Messagerie/MessagerieDashboard';
import ProfilePageModern from '../ProfilePageModern';
import GestionBackups from '../../components/GestionBackups';
import BaticoConfigV3 from '../../components/BaticoConfigV3';
import RemindersDashboard from '../../components/RemindersDashboard';

// Import des nouveaux composants Pro
import NomenclatureManagementPro from '../NomenclatureManagementPro';
import CategoriesManagementPro from '../CategoriesManagementPro';
import CollectionsManagementPro from '../CollectionsManagementPro';
import GestionTarifsDemandesPubliques from '../GestionTarifsDemandesPubliques';
import ExportStatistiquesAvance from '../../components/ExportStatistiquesAvance';
import AdminMembresCreation from '../../components/AdminMembresCreation';
import GestionIdentifiants from '../../components/GestionIdentifiants';
import GestionPlans from '../../components/GestionPlans';
import AdminSubscriptionTypes from '../../components/AdminSubscriptionTypes';
import GestionFinancierePlans from '../../components/GestionFinancierePlans';
import RegistreFiscal from '../../components/RegistreFiscal';
import RegistreMaitresOuvrage from '../../components/RegistreMaitresOuvrage';
import RegistreAdherentsFTPE from '../../components/RegistreAdherentsFTPE';
import GestionCredits from '../../components/GestionCredits';
import AdminCreditsGuideEditor from '../../components/AdminCreditsGuideEditor';
import GestionPromotions from '../../components/GestionPromotions';

import ScheduledBonusManager from '../../components/ScheduledBonusManager';
import FTPEAdhesionsDashboard from '../../components/FTPEAdhesionsDashboard';
import FTPEVirementValidation from '../../components/FTPEVirementValidation';
// FTPERegistreAdherentsAdmin: module SUPPRIMÉ (26/05/2026).
import RegistresCustomAdmin from '../../components/RegistresCustomAdmin';
import ReleasedAccountsAdmin from '../../components/ReleasedAccountsAdmin';
import FunnelsEventsDashboard from '../../components/FunnelsEventsDashboard';
import AnalyticsDashboard from '../../components/AnalyticsDashboard';
import AnnouncementsManager from '../../components/AnnouncementsManager';
import FTPESubscriptionForMember from '../../components/FTPESubscriptionForMember';
import ConventionPaymentsDashboard from '../../components/ConventionPaymentsDashboard';
import StripeNotificationsAdmin from '../../components/StripeNotificationsAdmin';
import StatsActivitesDashboard from '../../components/StatsActivites';
import CarteVivanteAdmin from '../../components/CarteVivante/CarteVivanteAdmin';
import VirementAlertsManager from '../../components/VirementAlertsManager';
import CreditAuditLogs from '../../components/CreditAuditLogs';
import KPIDashboard from '../../components/KPIDashboard';
import SimulateurDOS from '../../components/SimulateurDOS';
import GestionFinanciereDOMIUM from '../../components/GestionFinanciereDOMIUM';
import AlertesEcheances from '../../components/AlertesEcheances';
import EmailTrackingDashboard from '../../components/EmailTrackingDashboard';
import EmailPreview from '../../components/EmailPreview';
import ClientEmailsConfig from '../../components/ClientEmailsConfig';
import EmailAuditLog from '../../components/EmailAuditLog';
import RCDSSouscriptionsDashboard from '../../components/RCDSSouscriptionsDashboard';
import DOSDomiumDashboard from '../../components/DOSDomiumDashboard';
import RegistreQRCodes from '../../components/RegistreQRCodes';

import ValidationManuelleTab from '../../components/ValidationManuelleTab';
import RGPDZipSharesAuditPanel from '../../components/RGPDZipSharesAuditPanel';
import RGPDUnifiedRegistryPanel from '../../components/RGPDUnifiedRegistryPanel';
import SeuilsEchelonnementWidget from '../../components/Admin/SeuilsEchelonnementWidget';
import PropositionsSigneesWidget from '../../components/PropositionsSigneesWidget';
import PropositionsActivityChart from '../../components/PropositionsActivityChart';
import PropositionsESSRegistre from '../../components/PropositionsESSRegistre';
import SuiviSignatures from '../../components/admin/SuiviSignatures';
import { getToken } from '../../services/tokenService';

const _BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Onglets du dashboard
const _TABS = [
  { id: 'overview', label: 'Vue d\'ensemble', icon: BarChart3 },
  { id: 'validation-manuelle', label: 'Majorations personnalisées', icon: Award },
  { id: 'kpi-dashboard', label: '📈 KPIs', icon: TrendingUp },
  { id: 'analytics', label: '📊 Analytics', icon: TrendingUp },
  { id: 'announcements', label: '📢 Annonces', icon: Megaphone },
  { id: 'ftpe-adhesions', label: '🏢 Adhésions FTPE', icon: Building },
  { id: 'ftpe-virements', label: '🏦 Validation Virements', icon: Landmark },
  { id: 'registres-custom', label: '📚 Registres Custom', icon: BookOpen },
  { id: 'released-accounts', label: '♻️ Comptes libérés', icon: History },
  { id: 'funnels-events', label: '🎯 Funnels & Events', icon: Activity },
  { id: 'conventions-paiements', label: '💳 Conventions Payantes', icon: CreditCard },
  { id: 'communications-section', label: 'COMMUNICATION & ALERTES', isSeparator: true },
  { id: 'alertes-virements', label: '🔔 Alertes Virements', icon: Bell },
  { id: 'alertes-echeances', label: 'Alertes Echeances', icon: Mail },
  { id: 'email-tracking', label: 'Suivi Emails', icon: Mail },
  { id: 'email-preview', label: '✉️ Aperçu Emails', icon: Mail },
  { id: 'demandes-partenariat', label: '🤝 Partenariats', icon: Handshake },
  { id: 'demandes-remises', label: '♻️ Demandes remises', icon: Recycle },
  { id: 'partenariats-section', label: 'COMPTES, PLANS & CRÉDITS', isSeparator: true },
  { id: 'identifiants', label: '🔑 Identifiants', icon: Key },
  { id: 'plans', label: '📦 Plans', icon: Package },
  { id: 'subscription-types', label: '🏷️ Types de souscription', icon: Layers },
  { id: 'factures-plans', label: '💼 Factures Plans (PADH-)', icon: FileText },
  { id: 'propositions-signees', label: '✍️ Propositions signées', icon: FileSignature },
  { id: 'registre-pcs', label: '📜 Registre PCS (ESS)', icon: Award },
  { id: 'seuils-echelonnement', label: '💳 Seuils SEPA échelonnés', icon: CreditCard },
  { id: 'registre-fiscal', label: '⚖️ Registre Fiscal', icon: FileText },
  { id: 'registre-maitres-ouvrage', label: "🏗️ Registre Maîtres d'ouvrage", icon: FileText },
  { id: 'registre-adherents-ftpe', label: '🏢 Registre Adhérents FTPE', icon: FileText },
  { id: 'credits', label: '🪙 Crédits', icon: CreditCard },
  { id: 'credits-guide-cms', label: '📖 Guide Crédits (CMS)', icon: BookOpen },
  { id: 'audit-credits', label: '📋 Audit Crédits', icon: Shield },
  { id: 'bonus-programmes', label: '🎁 Bonus Programmés', icon: Gift },
  { id: 'promotions', label: '⚡ Promos Flash', icon: Zap },
  { id: 'gestion-membres', label: 'Création Membres', icon: UserPlus },
  { id: 'comptes-test', label: '🧪 Comptes de test', icon: UserPlus, externalRoute: '/admin/comptes-test' },
  { id: 'export-stats', label: '📊 Export & Stats', icon: TrendingUp },
  { id: 'ged-section', label: 'GED & DOCUMENTATION', isSeparator: true },
  { id: 'backups', label: '💾 Backups', icon: HardDrive },
  { id: 'rgpd-zip-shares', label: '🛡️ Audit RGPD ZIP', icon: Shield },
  { id: 'rgpd-unified', label: '🛡️ Registre RGPD Unifié', icon: Shield },
  { id: 'ged-ess', label: 'GED ESS', icon: FolderOpen },
  { id: 'ged-statistiques', label: 'Statistiques GED', icon: BarChart3 },
  { id: 'cartographie', label: 'Cartographie', icon: Globe },
  { id: 'collections', label: 'Collections', icon: Database },
  { id: 'categories', label: 'Catégories', icon: FolderOpen },
  { id: 'nomenclatures', label: 'Nomenclatures', icon: BookOpen },
  { id: 'simulateurs-separator', label: '🎯 SIMULATEURS MAÎTRES', isSeparator: true },
  { id: 'simulateur-batico', label: '🧮 BATICO Calculateur', icon: Calculator },
  { id: 'simulateur-dos', label: 'DOS-DOMIUM', icon: Home },
  { id: 'cockpit-ccmi', label: '🏗️ Cockpit CCMI', icon: Building2, externalRoute: '/admin/ccmi-dashboard' },
  { id: 'gestion-financiere-domium', label: '💰 Gestion Financière DOMIUM', icon: CreditCard },
  { id: 'batico-config-advanced', label: '🚀 Config BATICO Avancée', icon: Settings },
  { id: 'coopers-experts', label: "COOPER'S & EXPERTS", icon: Building },
  { id: 'suivi-section', label: 'SUIVI & TRAÇABILITÉ', isSeparator: true },
  { id: 'rappels-dashboard', label: "🔔 Suivi Rappels", icon: Bell },
  { id: 'factures-recus', label: "Factures et reçus ESS", icon: Receipt },
  { id: 'suivi-rcds', label: 'Suivi RCDS', icon: Shield },
  { id: 'suivi-dos-domium', label: 'Suivi DOS DOMIUM', icon: Building2 },
  { id: 'tarifs-demandes', label: 'Tarifs Leads', icon: DollarSign },
  { id: 'conventions', label: 'Conventions Partenariat', icon: FileText },
  { id: 'videos', label: 'Vidéos', icon: Video },
  { id: 'operations-section', label: 'OPÉRATIONS & SYSTÈME', isSeparator: true },
  { id: 'export-import', label: 'Export/Import', icon: Database },
  { id: 'alerts', label: 'Alertes', icon: AlertTriangle },
  { id: 'agenda', label: 'Agenda', icon: Calendar },
  { id: 'roles', label: 'Rôles', icon: Shield },
  { id: 'assignments', label: 'Assignations', icon: Users },
  { id: 'messagerie', label: 'Messagerie', icon: Mail },
  { id: 'config-emails-clients', label: 'Config Emails Clients', icon: Mail },
  { id: 'journal-emails', label: 'Journal Emails', icon: Mail },
  { id: 'registre-qr', label: 'Registre QR Codes', icon: QrCode },
  { id: 'code-health', label: '⚙️ Code Health', icon: Activity },
  { id: 'nav-config', label: '🧭 Navigation (onglets)', icon: Layers, externalRoute: '/admin/navigation-config' },
  { id: 'frontoffice-nav', label: '🧭 Menus front-office', icon: Layers },
  { id: 'frontoffice-footer', label: '🦶 Pied de page', icon: Layers },
  { id: 'profil', label: 'Mon Profil', icon: User }
];

import SuperAdminOverview from './SuperAdminOverview';

export default function SuperAdminViews({ ctx }) {
  const { activeTab, admins: admins, assignments, getAuthHeader, handleDeleteAssignment, setShowAssignModal, t, user } = ctx;
  const _renderAssignments = () => (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold">{t('super_admin_dashboard.admin_assignments', 'Assignations Admin')}</h2>
          <p className="text-gray-500">Gérez les assignations entre admins et utilisateurs</p>
        </div>
        <Button onClick={() => setShowAssignModal(true)}>
          <UserPlus className="h-4 w-4 mr-2" />
          Nouvelle assignation
        </Button>
      </div>

      <Card>
        <CardContent className="pt-6">
          {assignments.length === 0 ? (
            <div className="text-center py-12 text-gray-500">
              <Users className="h-16 w-16 mx-auto mb-4 opacity-20" />
              <p>{t('super_admin_dashboard.no_assignments', 'Aucune assignation pour le moment')}</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50 border-b">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">{t('super_admin_dashboard.admin', 'Admin')}</th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">{t('super_admin_dashboard.assigned_user', 'Utilisateur assigné')}</th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">{t('super_admin_dashboard.type', 'Type')}</th>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">{t('super_admin_dashboard.date', 'Date')}</th>
                    <th className="px-4 py-3 text-center text-sm font-medium text-gray-700">{t('super_admin_dashboard.actions', 'Actions')}</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {assignments.map((assignment) => (
                    <tr key={assignment.id} className="hover:bg-gray-50">
                      <td className="px-4 py-3">
                        <p className="font-medium text-gray-900">
                          {assignment.admin_nom} {assignment.admin_prenom}
                        </p>
                      </td>
                      <td className="px-4 py-3">
                        <p className="font-medium text-gray-900">
                          {assignment.assigned_user_nom} {assignment.assigned_user_prenom || ''}
                        </p>
                      </td>
                      <td className="px-4 py-3">
                        <Badge className={
                          assignment.assigned_user_type === 'member' ? 'bg-green-700' :
                          assignment.assigned_user_type === 'cooper' ? 'bg-purple-700' :
                          'bg-orange-600'
                        }>
                          {assignment.assigned_user_type === 'member' ? 'Membre' :
                           assignment.assigned_user_type === 'cooper' ? "COOPER'S" : "EXPERT"}
                        </Badge>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-600">
                        {new Date(assignment.assigned_at).toLocaleDateString('fr-FR')}
                      </td>
                      <td className="px-4 py-3 text-center">
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => handleDeleteAssignment(assignment.id)}
                          className="text-red-600 hover:text-red-700 hover:bg-red-50"
                        >
                          <Trash2 className="h-4 w-4" />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <SuperAdminOverview ctx={ctx} />;
      case 'demandes-partenariat':
        return <GestionDemandesPartenariat getAuthHeader={getAuthHeader} />;
      case 'demandes-remises':
        return <RemisesStatsPanel getAuthHeader={getAuthHeader} />;
      case 'identifiants':
        return <GestionIdentifiants />;
      case 'plans':
        return <GestionPlans />;
      case 'subscription-types':
        return <AdminSubscriptionTypes token={getToken()} />;
      case 'factures-plans':
        return <GestionFinancierePlans />;
      case 'registre-pcs':
        return <PropositionsESSRegistre />;
      case 'suivi-signatures':
        return <SuiviSignatures />;
      case 'propositions-signees':
        return (
          <div className="space-y-6" data-testid="propositions-signees-page">
            <div>
              <h2 className="text-2xl font-bold text-gray-900">Propositions ESS signées — Validation</h2>
              <p className="text-sm text-gray-500 mt-1">
                Liste des propositions ESS BATICO signées électroniquement par les destinataires.
                Validez pour créer la souscription, ou refusez avec une raison.
              </p>
            </div>
            <PropositionsActivityChart />
            <PropositionsSigneesWidget />
          </div>
        );
      case 'seuils-echelonnement':
        return (
          <div className="space-y-6" data-testid="seuils-echelonnement-page">
            <div>
              <h2 className="text-2xl font-bold text-gray-900">Seuils de paiement échelonné (SEPA)</h2>
              <p className="text-sm text-gray-500 mt-1">
                Définissez à partir de quel montant la proposition de paiement échelonné (acompte + mensualités) est affichée dans les devis et propositions PDF.
                Modification immédiate sur tous les nouveaux PDF et simulateurs. Cache 60&nbsp;s.
              </p>
            </div>
            <SeuilsEchelonnementWidget />
          </div>
        );
      case 'registre-fiscal':
        return <RegistreFiscal />;
      case 'registre-maitres-ouvrage':
        return <RegistreMaitresOuvrage />;
      case 'registre-adherents-ftpe':
        return <RegistreAdherentsFTPE />;
      case 'email-preview':
        return <EmailPreview />;
      case 'credits':
        return <GestionCredits getAuthHeader={getAuthHeader} />;
      case 'credits-guide-cms':
        return (
          <div className="space-y-6">
            <div>
              <h2 className="text-2xl font-bold text-gray-900">Guide des Crédits ESS — CMS</h2>
              <p className="text-sm text-gray-500 mt-1">
                Personnalisez l&apos;affichage du « Guide des Crédits » pour chaque espace (Membre, COOPER&apos;S, Expert).
              </p>
            </div>
            <AdminCreditsGuideEditor />
          </div>
        );
      case 'audit-credits':
        return <CreditAuditLogs getAuthHeader={getAuthHeader} />;
      case 'ftpe-adhesions':
        return (
          <div className="space-y-6">
            <div className="flex justify-between items-center">
              <h2 className="text-2xl font-bold text-gray-900">Adhésions FTPE Outremer</h2>
              <FTPESubscriptionForMember onSuccess={() => {
                toast.success('Adhésion FTPE créée avec succès');
              }} />
            </div>
            <FTPEAdhesionsDashboard />
          </div>
        );
      case 'ftpe-virements':
        return <FTPEVirementValidation />;
      case 'registres-custom':
        return <RegistresCustomAdmin />;
      case 'released-accounts':
        return <ReleasedAccountsAdmin />;
      case 'funnels-events':
        return <FunnelsEventsDashboard />;
      case 'conventions-paiements':
        return <ConventionPaymentsDashboard />;
      case 'stripe-notifications':
        return <StripeNotificationsAdmin />;
      case 'stats-activites':
        return <StatsActivitesDashboard />;
      case 'kpi-dashboard':
        return <KPIDashboard userRole="super_admin" />;
      case 'validation-manuelle':
        return <ValidationManuelleTab />;
      case 'simulateur-batico':
        return (
          <div className="space-y-6">
            {/* Bandeau institutionnel BATICO */}
            <div className="relative overflow-hidden rounded-2xl shadow-2xl border border-amber-200/30 text-white"
                 style={{ background: `radial-gradient(circle at 20% 0%, rgba(255,255,255,0.10), transparent 55%), linear-gradient(135deg, #0a1e3f 0%, #0B3C5D 60%, #0a1e3f 100%)` }}>
              <div className="absolute inset-0 opacity-[0.06] pointer-events-none">
                <div className="absolute top-0 right-0 w-72 h-72 bg-white rounded-full blur-3xl -translate-y-32 translate-x-32" />
              </div>
              <div className="relative px-6 sm:px-8 py-7">
                <div className="flex items-center gap-2 text-[10.5px] uppercase tracking-[0.22em] text-white/85 mb-3">
                  <span className="inline-block w-7 h-px bg-amber-300/80" />
                  <span className="font-semibold">COPPAM</span>
                  <span className="text-white/40">|</span>
                  <span>RCDS BATICO</span>
                  <span className="text-white/40">|</span>
                  <span>Calcul officiel certifié</span>
                </div>
                <div className="flex items-start gap-5">
                  <div className="hidden sm:flex relative flex-shrink-0">
                    <div className="absolute inset-0 bg-amber-300/20 rounded-2xl blur-xl" />
                    <div className="relative inline-flex items-center justify-center w-[68px] h-[68px] rounded-2xl bg-white/12 backdrop-blur-md border border-white/25 shadow-xl">
                      <Calculator className="h-9 w-9 drop-shadow-lg" />
                    </div>
                  </div>
                  <div className="min-w-0 flex-1">
                    <h2 className="text-[clamp(1.25rem,2vw,1.7rem)] leading-[1.05] font-black tracking-tight" style={{ fontFamily: '"Playfair Display", "Georgia", serif' }}>
                      SIMULATEUR CADRE <span className="text-amber-200">RCDS&nbsp;BATICO</span>
                    </h2>
                    <p className="mt-2 text-[14px] text-white/90 font-medium max-w-3xl">
                      Responsabilité civile et décennale — Articles 1792 et suivants du Code civil.
                    </p>
                    <div className="mt-1.5 space-y-0.5 text-[11px] text-white/65 leading-snug max-w-3xl">
                      <div>Cadre coopératif — Loi n° 47-1775 du 10 septembre 1947 portant statut de la coopération.</div>
                      <div>Économie sociale et solidaire — Loi n° 2014-856 du 31 juillet 2014 relative à l'ESS.</div>
                    </div>
                  </div>
                </div>
                <div className="mt-6 h-px bg-gradient-to-r from-transparent via-amber-300/60 to-transparent" />
                {/* CTAs */}
                <div className="mt-5 flex flex-wrap gap-3">
                  <a href="/calculateur-batico" target="_blank" rel="noopener noreferrer">
                    <Button className="bg-amber-400 hover:bg-amber-300 text-[#0a1e3f] font-bold h-10 px-5 shadow-lg shadow-amber-500/20" data-testid="cta-batico-new">
                      <Calculator className="h-4 w-4 mr-2" />
                      Nouvelle Souscription
                    </Button>
                  </a>
                  <a href="/calculateur-batico?mode=avenant" target="_blank" rel="noopener noreferrer">
                    <Button variant="outline" className="bg-white/10 border-white/30 text-white hover:bg-white/20 font-semibold h-10 px-5" data-testid="cta-batico-avenant">
                      <FilePlus className="h-4 w-4 mr-2" />
                      Créer un Avenant
                    </Button>
                  </a>
                </div>
              </div>
            </div>
            {/* Cartes info coopératives */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
              {[
                { icon: '👥', label: 'Tous les membres', desc: 'Accès complet base adhérents' },
                { icon: '📊', label: 'Simulation complète', desc: 'CA, activités, modulateurs' },
                { icon: '✅', label: 'Validation directe', desc: 'Workflow Super Admin' },
                { icon: '📝', label: 'Avenants', desc: 'Modifs contrats existants', accent: true },
              ].map((c) => (
                <div key={c.label} className={`p-4 rounded-xl border ${c.accent ? 'bg-amber-50 border-amber-200' : 'bg-white border-slate-200'} hover:shadow-md transition-shadow`}>
                  <div className="text-2xl mb-1.5">{c.icon}</div>
                  <p className={`text-sm font-semibold ${c.accent ? 'text-amber-900' : 'text-slate-800'}`}>{c.label}</p>
                  <p className="text-[11px] text-slate-500 mt-0.5">{c.desc}</p>
                </div>
              ))}
            </div>
          </div>
        );
      case 'simulateur-dos':
        return <SimulateurDOS userRole="super_admin" />;
      case 'gestion-financiere-domium':
        return <GestionFinanciereDOMIUM />;
      case 'analytics':
        return <AnalyticsDashboard />;
      case 'announcements':
        return <AnnouncementsManager />;
      case 'alertes-virements':
        return <VirementAlertsManager />;
      case 'alertes-echeances':
        return <AlertesEcheances />;
      case 'email-tracking':
        return <EmailTrackingDashboard />;
      case 'bonus-programmes':
        return <ScheduledBonusManager />;
      case 'promotions':
        return <GestionPromotions getAuthHeader={getAuthHeader} />;
      case 'gestion-membres':
        return <AdminMembresCreation userRole="super_admin" />;
      case 'export-stats':
        return <ExportStatistiquesAvance getAuthHeader={getAuthHeader} />;
      case 'backups':
        return <GestionBackups getAuthHeader={getAuthHeader} />;
      case 'rgpd-zip-shares':
        return <RGPDZipSharesAuditPanel />;
      case 'rgpd-unified':
        return <RGPDUnifiedRegistryPanel />;
      case 'ged-ess':
        return (
          <div className="space-y-6">
            <GEDDossiers />
            <GEDUniverselle />
            <GEDESS userRole="super_admin" />
            <GEDDomium />
          </div>
        );
      case 'ged-statistiques':
        return <GEDStatistiques />;
      case 'cartographie':
        return <><CarteVivanteAdmin superAdmin /><details className="mt-6"><summary className="cursor-pointer text-sm font-semibold text-slate-600" data-testid="cartographie-detaillee-toggle">Cartographie détaillée (GPS, experts, COOPER'S)</summary><div className="mt-4"><CartographieGlobale getAuthHeader={getAuthHeader} /></div></details></>;
      case 'collections':
        return <CollectionsManagementPro />;
      case 'categories':
        return <CategoriesManagementPro />;
      case 'nomenclatures':
        return <NomenclatureManagementPro />;
      case 'batico-config-advanced':
        return <BaticoConfigV3 getAuthHeader={getAuthHeader} />;
      case 'coopers-experts':
        return <GestionCoopersExperts getAuthHeader={getAuthHeader} />;
      case 'rappels-dashboard':
        return <RemindersDashboard />;
      case 'factures-recus':
        return <ValidationVirementsESS />;
      case 'suivi-rcds':
        return <RCDSSouscriptionsDashboard getAuthHeader={getAuthHeader} userRole="super_admin" />;
      case 'suivi-dos-domium':
        return <DOSDomiumDashboard getAuthHeader={getAuthHeader} userRole="super_admin" />;
      case 'tarifs-demandes':
        return <GestionTarifsDemandesPubliques />;
      case 'conventions':
        return <GestionConventions />;
      case 'videos':
        return <VideoManager userRole="super_admin" showUpload={true} showDelete={true} />;
      case 'export-import':
        return <ExportImportData getAuthHeader={getAuthHeader} />;
      case 'alerts':
        return <AlertsExpiringContracts getAuthHeader={getAuthHeader} />;
      case 'agenda':
        return <AgendaPartage getAuthHeader={getAuthHeader} user={user} />;
      case 'roles':
        return <GestionRoles getAuthHeader={getAuthHeader} user={user} />;
      case 'assignments':
        return <GestionAssignations getAuthHeader={getAuthHeader} />;
      case 'messagerie':
        return <MessagerieDashboard />;
      case 'config-emails-clients':
        return <ClientEmailsConfig getAuthHeader={getAuthHeader} />;
      case 'journal-emails':
        return <EmailAuditLog getAuthHeader={getAuthHeader} />;
      case 'registre-qr':
        return <RegistreQRCodes />;
      case 'code-health':
        return <CodeHealthDashboard />;
      case 'frontoffice-nav':
        return <FrontOfficeNavPanel />;
      case 'frontoffice-footer':
        return <FrontOfficeFooterPanel />;
      case 'profil':
        return <ProfilePageModern userType="super_admin" />;
      default:
        return <SuperAdminOverview ctx={ctx} />;
    }
  };
  return renderContent();
}
